var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('router-view'),_c('FooterPart'),_c('cookie-consent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }